import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { api } from '@/lib/api';
import { apiRequest } from '@/lib/auth/msal-config';

/**
 * Hook to configure API client with MSAL token provider
 * Call this once in the app root to set up authenticated API requests.
 * Returns isReady flag so queries can wait for auth to be configured.
 */
export function useApiAuth() {
  const { instance, accounts } = useMsal();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (accounts.length === 0) {
      setIsReady(false);
      return;
    }

    const getAccessToken = async (): Promise<string> => {
      const request = {
        ...apiRequest,
        account: accounts[0],
      };

      try {
        const response = await instance.acquireTokenSilent(request);
        return response.accessToken;
      } catch (error) {
        console.error('Silent token acquisition failed, attempting interactive:', error);
        await instance.acquireTokenRedirect(request);
        throw new Error('Redirecting for authentication');
      }
    };

    api.setAccessTokenProvider(getAccessToken);
    setIsReady(true);
  }, [instance, accounts]);

  return { isReady };
}
